<template>
    <div class="query">
<!--        <div class="title">-->
<!--            <p class="return" @click="back">-->
<!--                <img src="~@public/img/user/login/jian.png"/>-->
<!--            </p>-->
<!--            驾驶证记分查询-->
<!--        </div>-->
        <van-cell-group>
            <van-field v-model="handlingId" clearable label="驾驶证号:" placeholder="请输入身份证号"/>
            <van-field v-model="licenseCard" clearable label="档案编号:" placeholder="请输入驾驶证档案编号"/>
            <!--<verification-code-input @setVerificationCode="getVerificationCode"
                                     ref="childFunction"></verification-code-input>-->
            <Vue2Verify ref="verify" v-if="show" @closeClick="show = false" @success='success'
                        :imgSize="{width:'310px',height:'155px'}"></Vue2Verify>
        </van-cell-group>
        <div class="btn-submit-div">
            <van-button type="info" size="large" @click="submit">查询</van-button>
        </div>
        <div class="boxList" v-if="listShow">
            <div class="boxList-item">
                <span>身份证号:</span>
                <span>{{ dataList.idNum }}</span>
            </div>
            <div class="boxList-item">
                <span>累计积分:</span>
                <span>{{ dataList.integral}}</span>
            </div>
        </div>
    </div>
</template>

<script>

    import {CellGroup, Field, Toast, Button} from 'vant'
    import VerificationCodeInput from "@/components/verification-code-input/VerificationCodeInput";
    import {queryApiMap} from "@/api/query";
    import { idCardRegex } from '@/utils/regex'
    import Vue2Verify from "@/views/signUp/verify/verify"

    export default {
        name: "LicenseQuery",
        components: {
            Vue2Verify,
            VerificationCodeInput,
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
            [Toast.name]: Toast,
            [Button.name]: Button
        },
        data() {
            return {
                show: false,
                handlingId: '', // 身份证号
                licenseCard: '', // 驾驶证编号
                receiveVerificationCode: {}, // 接收验证码子组件传来verificationInfo对象
                value: '',
                listShow: false, //查询结果的显示与隐藏
                dataList: {} //用于查询后存放数据
            }
        },
        mounted(){
            this.logger.visit('114','0')
        },
        methods: {
            onConfirm(value) {
                this.value = value;
            },
            /**
             * 接收验证码输入框组件传来的verificationInfo对象
             * @param value 验证码输入框verificationInfo对象
             */
            getVerificationCode(value) {
                this.receiveVerificationCode = value
            },

          submit() {
            if (!this.handlingId) {
              Toast('请输入身份证号')
            } else if(!idCardRegex(this.handlingId)) {
              Toast('请输入正确的身份证号')
            } else if (!this.licenseCard) {
              Toast('请输入驾驶档案编号')
            } else {
              this.show=true
            }
          },
          async success(val) {
            Toast.loading({
              duration: 0,       // 持续展示 toast
              forbidClick: true, // 禁用背景点击
              loadingType: 'spinner',
              message: '查询中...'
            })
            try {
              const data = {
                idNum: this.handlingId,
                dabh: this.licenseCard,
                genGuid: val.captchaVerification,
                validCode: val.captchaVerification
              }
              const res = await this.$httpUtils.postCommonUtils(`${queryApiMap.drivingScore}`, data)
              this.show = false
              Toast.clear()
              if (res.data.succ) {
                const dataList = {
                  idNum: this.handlingId.substring(0, 10) + '******' + this.handlingId.substring(16, 18),
                  integral: res.data.data
                }
                this.dataList = dataList
                this.listShow = true
                // 清空身份证号
                this.handlingId = ''
              } else {
                Toast.fail('查询失败，请核实身份信息')
              }
              this.logger.visit('114','1')
            } catch (error) {
              Toast.fail('服务器运行失败，请稍后再试。')
              console.log(error)
            }
          },

            /**
             * 点击查询
             */
            async query() {
                if (!this.handlingId) {
                    Toast('请输入身份证号')
                } else if(!idCardRegex(this.handlingId)) {
                    Toast('请输入正确的身份证号')
                } else if (!this.licenseCard) {
                    Toast('请输入驾驶档案编号')
                } else if (!this.receiveVerificationCode.verificationIsNoneStatus) {
                    Toast('请输入验证码')
                } else if (!this.receiveVerificationCode.verificationSuccessStatus) {
                    Toast('请输入正确的验证码')
                } else {
                    Toast.loading({
                        duration: 0,       // 持续展示 toast
                        forbidClick: true, // 禁用背景点击
                        loadingType: 'spinner',
                        message: '查询中...'
                    })
                    try {
                        const data = {
                            idNum: this.handlingId,
                            dabh: this.licenseCard,
                            genGuid: this.receiveVerificationCode.verificationCodeGuid,
                            validCode: this.receiveVerificationCode.verificationCode
                        }
                        const res = await this.$httpUtils.postCommonUtils(`${queryApiMap.drivingScore}`, data)
                        if (res.data.succ) {
                            Toast.clear()
                            const dataList = {
                                idNum: this.handlingId.substring(0, 10) + '******' + this.handlingId.substring(16, 18),
                                integral: res.data.data
                            }
                            this.dataList = dataList
                            this.listShow = true
                            // 清空身份证号
                            this.handlingId = ''
                            // 清空验证码
                            this.$refs.childFunction.clearContent()
                            // 重新获取验证码
                            this.$refs.childFunction.interactionVerificationCode()
                        } else {
                            Toast.fail('查询失败，请核实身份信息')
                            // 清空验证码
                            this.$refs.childFunction.clearContent()
                            // 重新获取验证码
                            this.$refs.childFunction.interactionVerificationCode()
                        }
                        this.logger.visit('114','1')
                    } catch (error) {
                        Toast.fail('服务器运行失败，请稍后再试。')
                        console.log(error)
                    }
                }
            },
            back() {
                this.$router.go(-1);
            }
        }
    }
</script>

<style scoped>

</style>
<style>
    .query .van-field__label{
        width: 1.95rem;
    }
</style>
